const cardItems = [
  {
    title: '如何打造专属追剧清单',
    desc: '教你根据个人喜好高效整理观影列表，追剧效率翻倍的小技巧分享。',
    tag: '追剧攻略',
    img: 'https://readdy.ai/api/search-image?query=Organized%20movie%20watchlist%20on%20digital%20screen%20with%20warm%20cozy%20lighting%2C%20productivity%20and%20entertainment%20lifestyle%20concept%2C%20minimalist%20tech%20aesthetic%2C%20soft%20golden%20ambient%20light%2C%20modern%20home%20office%20vibe&width=600&height=380&seq=cards-01-playlist&orientation=landscape',
    alt: '91影视看片下载 - 追剧清单攻略',
  },
  {
    title: '2026年最值得期待的十部电影',
    desc: '科幻、动作、悬疑全都有，下半年片单提前锁定，每一部都不容错过。',
    tag: '影视前瞻',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20movie%20calendar%20wall%20display%20with%20upcoming%20film%20posters%2C%20warm%20cinema%20atmosphere%2C%20anticipation%20and%20excitement%20theme%2C%20golden%20and%20deep%20red%20aesthetic%2C%20professional%20entertainment%20visual&width=600&height=380&seq=cards-02-2026&orientation=landscape',
    alt: '91影视看片下载 - 2026电影前瞻',
  },
  {
    title: '国产剧崛起：今年必看的五部佳剧',
    desc: '从古装悬疑到都市情感，国产剧质量飞跃，这几部良心剧值得细品。',
    tag: '国产剧评',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20and%20modern%20drama%20stills%20collage%2C%20elegant%20traditional%20costume%20and%20urban%20scenes%2C%20warm%20cinematic%20lighting%2C%20cultural%20entertainment%20aesthetic%2C%20rich%20color%20palette&width=600&height=380&seq=cards-03-chinese&orientation=landscape',
    alt: '91影视看片下载 - 国产剧推荐',
  },
  {
    title: '周末观影指南：全家一起看的电影',
    desc: '适合全家人周末一起观看的合家欢电影推荐，温馨又欢乐的选择。',
    tag: '观影指南',
    img: 'https://readdy.ai/api/search-image?query=Family%20movie%20night%20scene%20with%20cozy%20living%20room%2C%20parents%20and%20children%20watching%20film%20together%2C%20warm%20home%20theater%20lighting%2C%20happy%20family%20entertainment%20vibe%2C%20soft%20golden%20ambient%20glow&width=600&height=380&seq=cards-04-family&orientation=landscape',
    alt: '91影视看片下载 - 合家欢电影推荐',
  },
  {
    title: '韩剧迷必收：近三年高分韩剧盘点',
    desc: '豆瓣评分8.0以上的韩剧精选合集，从悬疑到浪漫，追剧清单一次更新。',
    tag: '韩剧盘点',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20collection%20with%20romantic%20and%20thriller%20elements%2C%20elegant%20Korean%20entertainment%20aesthetic%2C%20warm%20dramatic%20lighting%2C%20professional%20drama%20review%20concept%2C%20trendy%20Asian%20media%20visual%20style&width=600&height=380&seq=cards-05-korean&orientation=landscape',
    alt: '91影视看片下载 - 韩剧盘点',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            观影指南
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            影视资讯与观影攻略
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            最新影视资讯、观影指南和精彩影评，帮您更好地享受追剧时光
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item, idx) => (
            <article
              key={idx}
              className={`group bg-background-100 rounded-xl overflow-hidden transition-all duration-300 cursor-pointer ${
                idx === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'aspect-[16/7] lg:aspect-[16/5]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                    (el.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}